<template>
    <div>
        <TableList :columns="columns" :get_table_list="this.get_table_list" :form_data_seo="form_data_seo"
            :slot_table_list="['operation']" ref="list" :rowKey="'tray_id'" >
            <template slot="right_btn">
                <export-table v-if="this.$store.state.page_auth.export" url="/manage/crm.tray/exportTray">
				</export-table>
                <!-- <a-button class="float_left" v-auth="'change'" @click="download()" type="primary">导出</a-button> -->
            </template>
            <template slot="operation" slot-scope="data">
                <a @click="go_detail(data.record)">查看</a>
                <!-- <a-divider type="vertical" />
                <a @click="go_product(data.record)">承运商绑定</a> -->
            </template>
        </TableList>
    </div>
</template>
<script>
    // @ is an alias to /src
    import Form from "@/components/Form";
    import TableList from "@/components/TableList";
    import EditPop from "@/components/EditPop";
    import {
        get_tray_list,
        get_tray_select
    } from '@/api/push'
    const columns = [
		{
		        title: "托盘单号",
		        dataIndex: "order_no",
		    },{
            title: "经销商",
            dataIndex: "seller_name",
        },
        {
            title: "司机",
            dataIndex: "chauffeur",
        },
        {
            title: "司机电话",
            dataIndex: "chauffeur_mobile",
        },
        {
            title: "车牌",
            dataIndex: "truck_license",
        },
        {
            title: "数量",
            dataIndex: "total_num",
        },
        {
            title: "状态",
            dataIndex: "status_name",
        },
        {
            title: "归还时间",
            dataIndex: "create_time",
        },
        {
            title: "操作",
            scopedSlots: {
                customRender: "operation"
            }
        }
    ];


    export default {
        name: "Index",
        components: {
            Form,
            TableList,
        },
        data() {
            return {
                get_table_list: get_tray_list,
                columns,
                visible: false,
                form_data_seo: {
                    ...this.$config.form_data_seo,
                    list: [

                        {
                            type: "text",
                            name: "keyword",
                            title: "关键词",
                            placeholder: "请输入关键词",
                            options: {}
                        },
						{
						    type: "text",
						    name: "order_no",
						    title: "托盘单号",
						    placeholder: "请输入托盘单号",
						    options: {}
						},
						
                        {
                            type: "range_date",
                            name: "range_date",
                            title: "时间",
                            options: {},
                            start: {
                                name: 'start_time'
                            },
                            end: {
                                name: 'end_time'
                            },
                        },
                        {
                            type: "select",
                            name: "status",
                            list: [],
                            title: "状态",
                            options: {}
                        },
                    ],
                },
            };
        },
        created() {
            this.get_select()
        },
        methods: {
            //下拉
            get_select() {
                get_tray_select().then(res=>{
                    this.form_data_seo.list = this.$method.set_form_list(this.form_data_seo.list, 'status', 'list', res.data.list)
                })
            },
            //查看司机信息
            go_detail(e) {
                this.$keep_route.add(this.$options.name);
                this.$router.push({
                    path: '/tray/detail',
                    query: {
                        id: e.tray_id
                    }
                })
            },
        }
    };
</script>
